import { post } from "@/axios/http.js"
import qs from 'qs'

export const changeUserPassword = (params) => post(`/api/User/ChangePassword?${qs.stringify(params)}`)


export const checkThirdPartToken = (data) => post(`/api/Login/TPLogin`, data)